import {
  MapPin,
  Phone,
  Facebook,
  Twitter,
  Youtube,
  Instagram,
} from "lucide-react";
import "../../../assets/css/customer/ADfooter/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Top Section - Showroom Info */}
        <div className="footer-top">
          <div className="showroom-info">
            <h2 className="showroom-title">VISIT OUR SHOWROOM</h2>
            <p className="showroom-address">
              Jandu Road Near Amir General Store, Canal View, Daska, Pakistan
            </p>
            <p className="showroom-hours">
              Mon - Sat: 7 am - 9 pm <span className="separator">|</span> Fri:
              Closed
            </p>
          </div>
          <div className="footer-actions">
            <a href="tel:03338170801" className="phone-number">
              <Phone size={24} />
              0333-8170801
            </a>
          </div>
        </div>

        <div className="footer-divider"></div>

        {/* Bottom Section - Links and Newsletter */}
        <div className="footer-bottom">
          <div className="footer-columns">
            {/* Browse By */}
            <div className="footer-column">
              <h3 className="column-title">BROWSE BY</h3>
              <ul className="column-links">
                <li>
                  <a href="/products">Products</a>
                </li>
                <li>
                  <a href="/browse-bidding">Active Bids</a>
                </li>
              </ul>
            </div>

            {/* Our Company */}
            <div className="footer-column">
              <h3 className="column-title">OUR COMPANY</h3>
              <ul className="column-links">
                <li>
                  <a href="/our-story">About</a>
                </li>
                <li>
                  <a href="/contact-us">Contact</a>
                </li>
              </ul>
            </div>

            {/* Customer Support */}
            <div className="footer-column">
              <h3 className="column-title">CUSTOMER SUPPORT</h3>
              <ul className="column-links">
                <li>
                  <a href="/privacy-policy">Privacy Policy</a>
                </li>
                <li>
                  <a href="/return-policy">Return Policy</a>
                </li>
                <li>
                  <a href="/terms-conditions">Terms &amp; Conditions</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer Copyright and Social */}
        <div className="footer-copyright">
          <div className="social-links">
            <a href="#facebook" className="social-icon" aria-label="Facebook">
              <Facebook size={20} />
            </a>
            <a href="#twitter" className="social-icon" aria-label="Twitter">
              <Twitter size={20} />
            </a>
            <a href="#youtube" className="social-icon" aria-label="YouTube">
              <Youtube size={20} />
            </a>
            <a href="#instagram" className="social-icon" aria-label="Instagram">
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;